import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import type { Role, Permission } from '@/types'

interface Props {
  children: ReactNode
  requiredRole?: Role[]
  requiredPermission?: Permission
  redirectTo?: string
}

export function ProtectedRoute({
  children,
  requiredRole,
  requiredPermission,
  redirectTo = '/login',
}: Props) {
  const { user, loading, hasPermission } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-text-secondary">
        Carregando...
      </div>
    )
  }

  if (!user) return <Navigate to={redirectTo} replace />

  if (requiredRole && !requiredRole.includes(user.role)) {
    return <Navigate to="/" replace />
  }
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/" replace />
  }
  return <>{children}</>
}
